module.exports = __webpack_public_path__ + "static/media/29COICT2.ff44e042.jpg";